import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { ExcludeFromDebtManagement } from '../../components/ExcludeFromDebtManagement/ExcludeFromDebtManagement';
import { InterestRate } from '../../components/InterestRate/InterestRate';
import { MonthlyContribution } from '../../components/MonthlyContribution/MonthlyContribution';
import { Property } from '../../components/Property/Property';
import { MortgageType } from '../../components/MortgageType/MortgageType';
import { OriginationDate } from '../../components/OriginationDate/OriginationDate';
import { MonthlyPmi } from '../../components/MonthlyPmi/MonthlyPmi';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  const { watch } = useFormContext();

  const associatedAssetId = watch('bankAccount.AssociatedAssetId');

  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountDescription />
      <AccountNickname />
      <Property />
      <MortgageType />
      <Balance label="Outstanding Balance" />
      <InterestRate label="Interest Rate" />
      <MonthlyContribution label="Monthly Payment" />
      <OriginationDate />
      <MonthlyPmi />
      {!associatedAssetId && <ManagementStyle />}
      {!associatedAssetId && <AssetBucketing />}
      <ExcludeFromDebtManagement />
    </TabWrapper>
  );
};

export const Mortgage = (props: FormComponentProps) => {
  return <TabsContent {...props} tabs={[{ name: 'Summary', Component: Summary }]} />;
};
